import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { TextMaskModule } from 'angular2-text-mask';
import { MyCurrencyPipe } from './pension-calculator/currency';
import { MyDatePickerModule } from 'mydatepicker';
import { CalculatorComponent } from './calculator.component';
import { CalculatorRoutingModule } from './calculator-routing.module';
import { PensionCalculatorSetupService } from './pension-calculator-setup/pension-calculator-setup.service';
import { PensionCalculatorService } from './pension-calculator/pension-calculator.service'
// import { HomeService } from '../home/home.service';
import { PensionCalculatorComponent } from './pension-calculator/pension-calculator.component';
import { PensionCalculatorSetupComponent } from './pension-calculator-setup/pension-calculator-setup.component';
import { CurrencyFormat } from '../../shared/pipes/currency-format.pipe';
// import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { AppToggle } from '../../shared/directives/toggle';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TooltipModule.forRoot(),
    CurrencyMaskModule,
    MyDatePickerModule,
    CalculatorRoutingModule,
    TextMaskModule,
    TranslateModule.forChild(),
    HttpClientModule
    // ScrollToModule.forRoot()
  ],
  declarations: [CalculatorComponent, PensionCalculatorComponent, PensionCalculatorSetupComponent,CurrencyFormat,MyCurrencyPipe, AppToggle],
  exports: [FormsModule, ReactiveFormsModule],
  providers : [PensionCalculatorSetupService, PensionCalculatorService]
})
export class CalculatorModule { }
